export function qptComponentReference(component = {}) {
  return String(component.component_id || component.ingredient_id || component.prep_recipe_id || "");
}

// Frozen versions use ingredient_id/prep_recipe_id while editable recipes use
// component_id. Match those stable references before any index fallback.
export function qptResolvedComponent(component = {}, resolvedComponents = [], index = -1) {
  const reference = qptComponentReference(component);
  const matched = (resolvedComponents || []).find(resolved => reference && [
    resolved.component_id, resolved.ingredient_id, resolved.prep_recipe_id,
  ].some(candidate => String(candidate || "") === reference));
  return matched || (index >= 0 ? (resolvedComponents || [])[index] || {} : {});
}

export function qptComponentDisplay(component = {}, resolved = {}) {
  const isPrep = component.component_type === "prep_recipe";
  const name = isPrep
    ? component.prep_recipe_name || component.recipe_name || component.prep?.recipe_name || resolved.prep_recipe_name || resolved.recipe_name || resolved.prep?.recipe_name
    : component.ingredient_name || component.name || component.ingredient?.ingredient_name || resolved.ingredient_name || resolved.name || resolved.ingredient?.ingredient_name;
  return name && String(name).trim() ? String(name).trim() : "Unknown component";
}
